module.exports = "https://static.wmbcdn.com/uniweb/images/1c247f2e300fd3a59361ec0834bacbe1.svg";